
import React, { useState } from "react";
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import "./CountryStateCitySelect.css"

function CountryStateCitySelect() {
  // State to hold selected values
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  // Convert data into react-select format
  const getOptions = (data, type) =>
    data.map((item) => ({ value: item.isoCode, label: item.name }));

  return (
    <div className="row">
      <div className="col-lg-4">
        {/* Country Select Box */}
        <label className="form-label">Select Country</label>
        <Select className=""
          options={getOptions(Country.getAllCountries(), "country")}
          value={selectedCountry}
          onChange={(country) => {
            setSelectedCountry(country);
            setSelectedState(null); // Reset state when country changes
            setSelectedCity(null);
          }}
          placeholder="Select Country"
        />
      </div>

      <div className="col-lg-4">    
        {/* State Select Box */}
        <label className="form-label">Select State</label>
        <Select
          options={selectedCountry ? getOptions(State.getStatesOfCountry(selectedCountry.value)) : []}
          value={selectedState}
          onChange={(state) => {
            setSelectedState(state);
            setSelectedCity(null); // Reset city when state changes
          }}
          placeholder="Select State"
          isDisabled={!selectedCountry}
        />
      </div>

      <div className="col-lg-4">        
        {/* City Select Box */}
        <label className="form-label">Select City</label>
        <Select
          options={
            selectedState
              ? getOptions(City.getCitiesOfState(selectedCountry.value, selectedState.value))
              : []
          }
          value={selectedCity}
          onChange={setSelectedCity}
          placeholder="Select City"
          isDisabled={!selectedState}
        />
      </div>
    </div>
  );
}

export default CountryStateCitySelect;
